'use client'

import { cn } from '@/shared/lib'

import { ContractBarInfo } from '../lib/contract-bars'

const BAR_COLORS = ['bg-blue-300 opacity-70', 'bg-blue-500 opacity-70'] as const

interface ContractBarsProps {
  /** 해당 날짜에 그려야 할 범위 정보 배열 */
  contractBarInfos?: ContractBarInfo[]
  /** 최대 레인 수 (해당 주 기준) */
  weekMaxLanes?: number
}

const BAR_HEIGHT = 4
const BARS_MIN_HEIGHT = 16

/**
 * 날짜 셀에 그려지는 계약 바 컴포넌트
 * - 주별 maxLanes에 따라 높이가 동적으로 조정됨
 * - 같은 주의 모든 셀이 동일한 높이를 가지도록 maxLanes만큼 공간 확보
 * - 레인이 없어도 최소 16px 간격 유지
 */
export const ContractBars = ({
  contractBarInfos = [],
  weekMaxLanes = 0,
}: ContractBarsProps) => {
  // 전체 높이 계산 (레인 수 * 바 높이), 최소 16px 보장
  const calculatedHeight = weekMaxLanes * BAR_HEIGHT
  const totalHeight = Math.max(calculatedHeight, BARS_MIN_HEIGHT)

  return (
    <div
      className="pointer-events-none relative w-full bg-white!"
      style={{ height: totalHeight }}
    >
      {contractBarInfos.map(info => (
        <ContractBar
          key={info.rangeId}
          laneIndex={info.weeklyLaneIndex}
          colorIndex={info.colorIndex}
          isStart={info.isStart}
          isEnd={info.isEnd}
        />
      ))}
    </div>
  )
}

interface ContractBarProps {
  laneIndex: number
  colorIndex: number
  isStart: boolean
  isEnd: boolean
}

const ContractBar = ({
  laneIndex,
  colorIndex,
  isStart,
  isEnd,
}: ContractBarProps) => {
  const topOffset = laneIndex * BAR_HEIGHT
  const colorClass = BAR_COLORS[colorIndex % BAR_COLORS.length]

  return (
    <div
      className={cn(
        'absolute right-0 left-0 h-1',
        colorClass,
        isStart && 'rounded-l-full',
        isEnd && 'rounded-r-full',
      )}
      style={{
        top: topOffset,
      }}
    />
  )
}
